import React, { useState, useEffect } from "react"
import { useGlobal } from 'reactn'
import { Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import posed from 'react-pose'
import { useInView } from 'react-intersection-observer'
import * as Scroll from 'react-scroll'
import { animateScroll as scroll, Element, scroller } from 'react-scroll'
import IWF from '../components/image-with-fallback'
import Carousel from '../components/carousel'

import '../components/layout.css'

// animation 

const ArtistModal = posed.ul({
  hover: {
    delayChildren: 200,
    staggerChildren: 50,
  },
  noHover: { 
    delay: 300,
   },
 
})

const ArtistText = posed.li({
  hover: { y: 0, opacity: 1 },
  noHover: { y: 20, opacity: 0 }
})

const IndexContainer= posed.ul({
  load: {
    delayChildren: 200,
    staggerChildren: 150,
  },

  static: { 
    delay: 300 
  },
})

const IndexItem = posed.div({
  load: {
    x: '0%',
    opacity: 1,
    transition: { duration: 1000 },
  },
  static: { 
    x: '-5%',
    opacity: 0,
    delay: 300 },
})

const IndexBottomItem = posed.div({
  load: {
    y: '0%',
    opacity: 1,
    delayChildren: 1700,
    staggerChildren: 0,
    type: 'tween',
    
  },
  static: { 
    y: '100%',
    opacity: 0,
    delay: 300 
  },
})

// index page

const IndexPage = () => {

  // global state

  const [showConnectModal, setShowConnectModal] = useGlobal('showConnectModal')

  // local state

  const [isHovering, setHovering] = useState(false)
  const [isHoveringOne, setHoveringOne] = useState(false)
  const [isHoveringTwo, setHoveringTwo] = useState(false)
  const [animatePage, setAnimatePage] = useState(false)
  const [loaded, setLoaded] = useState(false)

  const [triggered, setTriggered] = useState(false)
    const [ref, inView] = useInView()

  useEffect(() => {
    if (inView) setTriggered(true)
    }, [inView])

  useEffect(() => {
    setTimeout(() => {setAnimatePage(true)}, 1000)
    setLoaded(true)
    console.log(loaded)
  }, []) 

  const handleConnectNow = () => {
    setShowConnectModal(true)
  }

  const secondFold = () => {
    
    return(
      <div className="index-scroll-view">
        <div className="future-artist-management" >
          {triggered ? <p className="sub-divider-heading">THE FUTURE OF ARTIST MANAGEMENT</p> : <div />}
        </div>
        <div className="bottom-container" ref={ref}>
          <div className="bottom-left-wrapper">
            {triggered ? <p className="meet-createsafe">CREATE O/S</p> : <p/ >}
            {triggered ? <p className="bottom-text-block">
            We are building a world where artists are in command. A first-of-its-kind CRM platform for creators to secure the necessary resources for making, managing, and marketing their art. Via our machine-human hybrid concierge, we deliver scalable management solutions and an unprecedented suite of tools for artists and managers alike. CreateSafe empowers creators and their teams to control their own enterprises through technology, executive development, agency marketing, and creative management services.
            </p> : <p />}
            {triggered ? <button className="connect-now cta" onClick={handleConnectNow}>CONNECT NOW</button> : <div />}
          </div>
          <div className="bottom-right-wrapper">
            {triggered ? <IWF fileName="meet-concierge-desktop" className="phone desktop-phone" /> : <div />}
          </div>
        </div> 
      </div>
    )
  }

  const homeDivider = () => {
    return (
      <div className='home-divider' onClick={() => {
        scroller.scrollTo('index-scroll-view', {
          duration: 500,
          delay: 100,
          smooth: true,
        })                        
        }}>
        <div className="what-is-createsafe">
          <span className='what-is-createsafe-text'>what is createsafe?</span>
          <IWF fileName="down-arrow" className='down-arrow' />
        </div>
      </div>
    )
  }

  

  if(!loaded) {
    return <div />
  }
  else {
    return (
      <div className="first-index-div">
        <div className="carousel">
          <Carousel/>
        </div>
        <div className="hide-index">
          <Layout location="index">
            <SEO title="Artist Services"  />
            <IndexContainer className="index" initialPose='static' pose='load'>
              <div className="index-wrapper">
                <div className="index-landing-view">
                  <div className="index-items">
                    <IndexItem className="index-top-heading-container">
                      <h1 className="index-top-heading">ARTIST SERVICES</h1>
                    </IndexItem>
                    <div className="artist-container">
                    <IndexItem className="artist-image-container">
                        <Link to="/management/" className="index-links">
                        <IWF fileName="home-artist-management" className="artist-pics"/>
                          <div className="picture-text" onMouseEnter={() => setHoveringTwo(true)} onMouseLeave={() => setHoveringTwo(false)}>
                            <ArtistModal className="picture-text-copy" pose={isHoveringTwo ? 'hover' : 'noHover'}>
                              <ArtistText className="services-bookend">SERVICES INCLUDE</ArtistText>
                                <div className="services-block">
                                  <ArtistText>NEGOTIATING DEALS</ArtistText> 
                                  <ArtistText>MANAGING FINANCES &amp; ACCOUNTING</ArtistText>
                                  <ArtistText>PAPERWORK ADMINISTRATION</ArtistText>
                                  <ArtistText>PLANNING TRAVEL &amp; ACCOMODATIONS</ArtistText>
                                  <ArtistText>TEAM MANAGEMENT</ArtistText>
                                  <ArtistText>BUSINESS STRATEGIZING</ArtistText>                                                                                    
                                </div>
                                <ArtistText className="services-bookend learn-more">LEARN MORE</ArtistText> 
                            </ArtistModal>                        
                          </div>
                        </Link> 
                      </IndexItem> 
                      <IndexItem className="artist-image-container middle">
                        <Link to="/development/" className="index-links">
                          <IWF fileName="home-artist-development" className="artist-pics"/>
                            <div className="picture-text" onMouseEnter={() => setHovering(true)} onMouseLeave={() => setHovering(false)}>
                              <ArtistModal className="picture-text-copy" pose={isHovering ? 'hover' : 'noHover'}>
                                <ArtistText className="services-bookend">SERVICES INCLUDE</ArtistText>
                                <div className="services-block">
                                    <ArtistText>SONGWRITING IMPROVEMENT</ArtistText>
                                    <ArtistText>SOUND DEVELOPMENT</ArtistText>
                                    <ArtistText>FINDING COLLABORATORS</ArtistText>
                                    <ArtistText>COORDINATING COLLABORATIONS</ArtistText>
                                    <ArtistText>PRODUCTION MANAGEMENT</ArtistText>
                                    <ArtistText>BRAND DEVELOPMENT</ArtistText>                                    
                                </div>
                                <ArtistText className="services-bookend learn-more">LEARN MORE</ArtistText>   
                            </ArtistModal>
                          </div>
                        </Link>
                      </IndexItem>                        
                      <IndexItem className="artist-image-container">
                        <Link to="/marketing/" className="index-links">
                          <IWF fileName="home-artist-marketing" className="artist-pics"/>
                            <div className="picture-text" onMouseEnter={() => setHoveringOne(true)} onMouseLeave={() => setHoveringOne(false)}>
                              <ArtistModal className="picture-text-copy" pose={isHoveringOne ? 'hover' : 'noHover'}>
                                <ArtistText className="services-bookend">SERVICES INCLUDE</ArtistText>
                                <div className="services-block">
                                  <ArtistText>CREATING MARKETING PLANS</ArtistText>
                                  <ArtistText>MANAGING PRESS STRATEGY</ArtistText>
                                  <ArtistText>PRODUCING MUSIC VIDEOS</ArtistText>
                                  <ArtistText>SECURING PLAYLIST PLACEMENTS</ArtistText>
                                  <ArtistText>MANAGING SOCIAL MEDIA CHANNELS</ArtistText>
                                  <ArtistText>BUILDING AWARENESS CAMPAIGNS</ArtistText>                                    
                                </div>
                                <ArtistText className="services-bookend learn-more">LEARN MORE</ArtistText> 
                            </ArtistModal>
                            </div>                      
                        </Link>
                      </IndexItem>           
                  </div>
                    <div className="services-container">
                      <Link to="/development/" className="index-links all-link">
                        {/* change ps to span */}
                        <IndexItem className="artist-service">MANAGEMENT</IndexItem> 
                      </Link>
                      <Link to="/marketing/" className="index-links middle all-link">
                        <IndexItem className="artist-service">DEVELOPMENT</IndexItem>
                      </Link>
                      <Link to="/management/" className="index-links all-link">
                        <IndexItem className="artist-service">MARKETING</IndexItem>
                      </Link>
                    </div>
                  </div>
                  {homeDivider()}                    
                </div>
                {secondFold()}
              </div>
            </IndexContainer>
          </Layout>
        </div>
      </div>
    )
  }
}

export default IndexPage
